{
  "title": "Prayer of Healing",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level evocation",
  "level": 2,
  "castingTime": "10 minutes",
  "range": "30 feet",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "Up to six creatures of your choice that you can see within range each regain hit points equal to 2d8 + your spellcasting ability modifier. This spell has no effect on undead or constructs.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the healing increases by 1d8 for each slot level above 2nd."
  ],
  "spellLists": ["cleric", "paladin"]
}
